<div class="col d-flex justify-content-end mx-2">
    <button type="button" class="btn btn-light action-button" [popover]="popTemplate" [adaptivePosition]="true"
        container="body" boundariesElement="viewport" placement="left">
        <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
        <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :"dd.MM.yyyy" }}</span>
    </button>

    <!-- Popover Template below-->
    <ng-template #popTemplate>
        <div class="popover">
            <div class="row">
                <div class="col d-flex justify-content-between">
                    <h2>Selectați intervalul</h2>
                    <button style="height: 40px; width: 100px" class="btn btn-light close-btn" (click)="closePopover()">
                        <img src="assets/icons/close.svg" alt="Închide" style="height: 20px; width: 20px" />
                        <span class="close-text">ÎNCHIDE</span>
                    </button>
                </div>
            </div>
            <div class="row mt-2 mb-2">
                <div class="col d-flex justify-content-between">
                    <button type="button" class="action-button"
                        [class.selected]="selectedFilteringButton === 'last_0_days'" (click)="setLastXDays(0)">
                        <span>AZI</span>
                    </button>
                    <button type="button" class="action-button"
                        [class.selected]="selectedFilteringButton === 'last_7_days'" (click)="setLastXDays(7)">
                        <span>7 ZILE</span>
                    </button>
                    <button type="button" class="action-button"
                        [class.selected]="selectedFilteringButton === 'last_30_days'" (click)="setLastXDays(30)">
                        <span>30 ZILE</span>
                    </button>
                    <button type="button" class="action-button"
                        [class.selected]="selectedFilteringButton === 'current_year'" (click)="setYear(0)">
                        <span>AN CURENT</span>
                    </button>
                    <button type="button" class="action-button"
                        [class.selected]="selectedFilteringButton === 'previous_year'" (click)="setYear(1)">
                        <span>AN ANTERIOR</span>
                    </button>
                </div>
            </div>
            <div class="datepicker-container">
                <div class="col">
                    <div class="datepicker-header">
                        <div class="text">DE LA:</div>
                        <div class="date">
                            {{ selectedStartDate | date : "mediumDate" }}
                        </div>
                    </div>
                    <mat-card>
                        <mat-calendar #startCalendar [startAt]="selectedStartDate" [(selected)]="selectedStartDate"
                            [maxDate]="today" [maxDate]="selectedEndDate"
                            (selectedChange)="this.rerenderDT()"></mat-calendar>
                    </mat-card>
                </div>
                <div class="col">
                    <div class="datepicker-header">
                        <div class="text">PANA LA:</div>
                        <div class="date">
                            {{ selectedEndDate | date : "mediumDate" }}
                        </div>
                    </div>
                    <mat-card>
                        <mat-calendar #endCalendar [(selected)]="selectedEndDate" [maxDate]="today"
                            (selectedChange)="rerenderDT()"></mat-calendar>
                    </mat-card>
                </div>
            </div>
        </div>
    </ng-template>
</div>
<div class="table-container">
    <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger">
    </table>
</div>
<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>